interface SectionHeadingProps {
  index: string;
  title: string;
  subtitle: string;
  meta?: string;
}

export default function SectionHeading({ index, title, subtitle, meta }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
      <div className="flex items-start gap-4 md:gap-5">
        <span className="mt-1 font-display text-3xl font-black leading-none text-primary-500 md:text-5xl">
          {index}
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            {subtitle}
          </p>
        </div>
      </div>
      {meta ? (
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-600">
          <i className="ri-refresh-line text-sm text-accent-600" />
          {meta}
        </span>
      ) : null}
    </div>
  );
}